<template>
  <footer
    :class="{
      'is-nav': isNav,
      dark: darkMode,
      mobile: isMobile
    }"
  >
    <p class="company">
      Sivona Hong Kong Limited
    </p>
    <div class="links">
      <router-link to="/qa">{{$t('upgrade_page_layout_header_11')}}</router-link>
      <a @click.prevent="$emit('echat')">{{$t('upgrade_page_layout_header_10')}}</a>
      <router-link to="/privacy">{{$t('upgrade_page_layout_footer_55')}}</router-link>
    </div>
    <div class="bottom">
      <span>Copyright © 2024 Nicee.</span>
      <!-- <div class="buttons">
        <a href="https://www.facebook.com/102768321269306/" target="_blank">
          <fps-icon type="facebook1" size="22" />
        </a>
        <a href="https://www.instagram.com/nicee_tw/?hl=zh-tw" target="_blank">
          <fps-icon type="instagram1" size="22" />
        </a>
        <a href="https://discord.gg/TUpC4svvQf" target="_blank">
          <fps-icon type="discord1" size="22" />
        </a>
      </div> -->
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      isMobile: window.innerWidth < 600
    };
  },
  props: {
    isNav: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
footer {
  position: relative;
  z-index: 99;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 66px;
  padding: 14px 20px 14px 20px;
  color: $color-gray-3;
  font-size: 12px;
  background-color: #fff;
  .company {
    padding-bottom: 10px;
  }
  &.is-nav {
    flex-shrink: 0;
    position: relative;
    height: 91px;
    .links {
      position: relative;
      left: 0;
      width: 100%;
      height: 17px;
      margin-bottom: 6px;
    }
    .bottom .buttons {
      width: 86px;
    }
  }
  &.dark {
    background-color: $color-gray-1;
    a {
      color: rgba($color: #fff, $alpha: 0.5);
      &:hover {
        color: #fff;
      }
    }
    .bottom span {
      color: rgba($color: #fff, $alpha: 0.25);
    }
    &.mobile {
      background-color: #323d4f;
      border-top: 1px solid rgba($color: #fff, $alpha: 0.1);
    }
  }
  .links {
    @include flex(space-between);
    position: absolute;
    left: 182px;
    width: 200px;
    height: 22px;
  }
  a {
    color: $color-gray-3;
    cursor: pointer;
    &:hover {
      color: $color-gray-1;
    }
  }
  .bottom {
    @include flex(space-between);
    height: 22px;
    .buttons {
      @include flex(space-between);
      width: 106px;
      a {
        display: block;
      }
    }
  }
}

@media screen and (max-width: 599px) {
  footer {
    height: auto;
    padding: 24px;
    .links {
      position: relative;
      left: 0;
      margin-bottom: 8px;
    }
    .bottom .buttons {
      width: 82px;
    }
  }
}
</style>
